import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    FETCH_PAYMENT_METHODS_V2_SUCCESS,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_SUCCESS,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES,
} from "../store/types";

export const INITIAL_STATE = {
    providers: [],
    message: null,
    // Set only by fetchPaymentMethodsV2. country/error come from the country
    // resolver; the limit envelopes are present only where pawaPay serves.
    country: null,
    depositLimits: null,
    payoutLimits: null,
    error: null,
    // Ported from production OTA 2026-08-21 (module 1367).
    loading: false,
    providersUid: null,
    errorCode: null
}

export const paymentreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_PAYMENT_METHODS:
          return {
            ...state,
            loading: true
          };
        case FETCH_PAYMENT_METHODS_V2_SUCCESS:
          return {
            ...state,
            providers: action.payload.providers,
            country: action.payload.country,
            depositLimits: action.payload.depositLimits,
            payoutLimits: action.payload.payoutLimits,
            error: action.payload.error,
            providersUid: action.payload.uid || null,
            errorCode: action.payload.error || null,
            loading: false,
            message: null
          };
        case FETCH_PAYMENT_METHODS_SUCCESS:
          return {
            ...state,
            providers: action.payload,
            loading: false
          };
        case FETCH_PAYMENT_METHODS_FAILED:
          // Limits from an earlier fetch must not keep validating amounts
          // once the list they came with is gone.
          return {
            ...state,
            message: action.payload,
            errorCode: action.errorCode || null,
            depositLimits: null,
            payoutLimits: null,
            loading: false
          };
        case UPDATE_WALLET_BALANCE:
          return {
            ...state
          };
        case UPDATE_WALLET_BALANCE_SUCCESS:
          return {
            ...state
          };
        case UPDATE_WALLET_BALANCE_FAILED:
          return {
            ...state,
            message: action.payload
          };
        case CLEAR_PAYMENT_MESSAGES:
          return {
            ...state,
            message:null
          };
        default:
          return state;
      }
};